import React, { FC, ReactNode } from 'react';
import { styled, Typography } from '@mui/material';
import { useContentView } from '../ContentViewContext';
import { Page } from '../../../declarations/models/Page';

export interface PageTreeLabelProps {
  page: Page;
}

const Highlight = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.getContrastText(theme.palette.primary.dark),
}));

export const PageTreeLabel: FC<PageTreeLabelProps> = ({ page }) => {
  const { filterValues } = useContentView();

  const query = String(filterValues.query || '')
    .trim()
    .toLowerCase();
  const label: string = String(page.title || '').trim();
  const labelLC = label.toLowerCase();

  let highlightedLabel: Array<ReactNode> | null = null;

  if (query && label && labelLC.includes(query)) {
    const startIdx = labelLC.indexOf(query);
    const endIdx = startIdx + query.length;
    highlightedLabel = [
      startIdx > 0 && label.substring(0, startIdx),
      <Highlight key={label}>{label.substring(startIdx, endIdx)}</Highlight>,
      endIdx < label.length && label.substring(endIdx),
    ];
  }

  return (
    <Typography
      component='span'
      variant='subtitle2'
      noWrap
      sx={{
        maxWidth: '30vw',
        fontSize: 'medium',
      }}>
      {highlightedLabel || label}
    </Typography>
  );
};

export default PageTreeLabel;
